import { Converter } from "@tblabs/storage";
import { RefSerializer, Collection } from "@tblabs/truffle";
import { ApplyForm } from "./ApplyForm";
import { JobOfferQuestionEntry } from "./JobOfferQuestionEntry";
import { RawApplyForm } from "./RawApplyForm";


export class ApplyFormConverter extends Converter<RawApplyForm, ApplyForm>
{
    public ConvertToRaw(application: ApplyForm): RawApplyForm
    {
        return RefSerializer.Flatenize(application) as unknown as RawApplyForm;
    }

    public ConvertFromRaw(raw: RawApplyForm): ApplyForm
    {
        try
        {
            const application = new ApplyForm(raw.Id);

            application.Position = this.GetString(raw.Position);
            application.Answers = this.GetList<JobOfferQuestionEntry>(raw.Answers, x => new JobOfferQuestionEntry(x.Question, x.Answer));
            application.Recruit.Name.value = this.GetString(raw.Recruit.Name);
            application.Recruit.Phone.value = this.GetString(raw.Recruit.Phone);
            application.Recruit.Email.value = this.GetString(raw.Recruit.Email);
            application.Recruit.City.value = this.GetString(raw.Recruit.City);
            application.CreatedAt = this.GetDate(raw.ApplyTime || raw.CreatedAt);

            return application;
        }
        catch (error)
        {
            console.log(error);
            return new ApplyForm(raw.Id);
        }
    }

    private GetList<T>(value: any, creator: (raw: any) => T): Collection<T>
    {
        const collection = value?.map(x => creator(x));

        return new Collection<T>(collection);
    }
}
